import { useMemo } from "react";

export interface ConfluenceSourceSettingsText {
  resourceLabelText: string;
  resourcePlaceholderText: string;
  spacesLabelText: string;
  spacesPlaceholderText: string;
  spacesHintText: string;
  assignedToMeLabelText: string;
  loadingResourcesText: string;
  loadingSpacesText: string;
  loadErrorText: string;
}

export const useConfluenceSourceSettingsText = (
  t: (key: string) => string,
): ConfluenceSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.confluence.${key}`);

    return {
      resourceLabelText: tKey("resourceLabel"),
      resourcePlaceholderText: tKey("resourcePlaceholder"),
      spacesLabelText: tKey("spacesLabel"),
      spacesPlaceholderText: tKey("spacesPlaceholder"),
      spacesHintText: tKey("spacesHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      loadingResourcesText: tKey("loadingResources"),
      loadingSpacesText: tKey("loadingSpaces"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
